import React, { useState } from 'react';
import { useData } from '../../hooks/useData';

import Sidebar from './Sidebar';
import TopBar from './TopBar';

import DashboardModule from '../dashboard/DashboardModule';
import DesignationManagement from '../Users/DesignationManagement/DesignationManagement';
import UserManagement from '../Users/UserManagement/UserManagement';
import SubAdminManagement from '../Users/UserManagement/SubAdminManagement';
import LogHistory from '../governance/LogHistory';
import FailedLoginHistory from '../governance/FailedLoginHistory';
import FolderManagement from '../FolderManagement/FolderManagement';
import DocumentTagManagement from '../Metadata/DocumentTagManagement/DocumentTagManagement';
import DocumentTypeManagement from '../Metadata/DocumentTypeManagement/DocumentTypeManagement';
import KnowledgeBaseMetadataManagement from '../Metadata/KnowledgeBaseMetadataManagement/KnowledgeBaseMetadataManagement';
import ProjectMilestoneManagement from '../Metadata/ProjectMilestoneManagement/ProjectMilestoneManagement';
import ReviewChecklistManagement from '../Metadata/ReviewChecklistManagement/ReviewChecklistManagement';
import AuditTrail from '../governance/AuditTrail';
import ChangePassword from '../Settings/ChangePassword';
import TwofactorAuth from '../Settings/TwofactorAuth';
import UserProfileSettings from '../Settings/UserProfileSettings';

const MODULES = {
  dashboard: {
    name: 'Dashboard',
    icon: 'ti-dashboard',
    group: 'workspace',
    crumbs: ['Workspace', 'Dashboard'],
    component: DashboardModule,
  },
  studies: {
    name: 'Document Folder',
    icon: 'ti-folder-open',
    group: 'workspace',
    crumbs: ['Workspace', 'Document Folder'],
    component: FolderManagement,
  },
  documentType: {
    name: 'Document Type',
    icon: 'ti-file-description',
    group: 'workspaceMetadata',
    crumbs: ['Workspace', 'Metadata', 'Document Type'],
    component: DocumentTypeManagement,
  },
  documentTag: {
    name: 'Document Tag',
    icon: 'ti-tags',
    group: 'workspaceMetadata',
    crumbs: ['Workspace', 'Metadata', 'Document Tag'],
    component: DocumentTagManagement,
  },
  knowledgeBaseMetadata: {
    name: 'Knowledgebase Metadata',
    icon: 'ti-brain',
    group: 'workspaceMetadata',
    crumbs: ['Workspace', 'Metadata', 'Knowledgebase Metadata'],
    component: KnowledgeBaseMetadataManagement,
  },
  projectMilestone: {
    name: 'Project Milestone',
    icon: 'ti-flag-3',
    group: 'workspaceMetadata',
    crumbs: ['Workspace', 'Metadata', 'Project Milestone'],
    component: ProjectMilestoneManagement,
  },
  reviewChecklist: {
    name: 'Review Checklist',
    icon: 'ti-checklist',
    group: 'workspaceMetadata',
    crumbs: ['Workspace', 'Metadata', 'Review Checklist'],
    component: ReviewChecklistManagement,
  },
  user: {
    name: 'Manage User',
    icon: 'ti-user-cog',
    group: 'users',
    crumbs: ['User Management', 'Manage User'],
    component: UserManagement,
  },
  userDesignation: {
    name: "Manage Designation",
    icon: "ti-shield-check",
    group: "users",
    crumbs: ["User Management", "Manage Designation"],
    component: (props) => (
      <DesignationManagement
        {...props}
        category="user"
      />
    ),
  },
  subadmin: {
    name: 'Manage Sub Admin',
    icon: 'ti-user-star',
    group: 'subadmins',
    crumbs: ['Sub Admin Management', 'Manage Sub Admin'],
    component: SubAdminManagement,
  },
  subadminDesignation: {
    name: 'Manage Designation',
    icon: 'ti-shield-check',
    group: 'subadmins',
    crumbs: ['Sub Admin Management', 'Manage Designation'],
    component: (props) => (
      <DesignationManagement
        {...props}
        category="subadmin"
      />
    ),
  },
  audit: {
    name: 'Audit trail',
    icon: 'ti-history',
    group: 'governance',
    crumbs: ['Governance', 'Audit trail'],
    component: AuditTrail,
  },
  logHistory: {
    name: 'Log History',
    icon: 'ti-history',
    group: 'governance',
    crumbs: ['Governance', 'Log History'],
    component: LogHistory,
  },
  failedLogHistory: {
    name: 'Failed Log History',
    icon: 'ti-history',
    group: 'governance',
    crumbs: ['Governance', 'Failed Log History'],
    component: FailedLoginHistory,
  },
  profile: {
    name: 'Profile',
    icon: 'ti-user-check',
    group: 'settings',
    crumbs: ['Settings', 'Profile'],
    component: UserProfileSettings,
  },
  changePassword: {
    name: 'Change Password',
    icon: 'ti-lock',
    group: 'settings',
    crumbs: ['Settings', 'Change Password'],
    component: ChangePassword,
  },
  twoFA: {
    name: 'Two factor Auth',
    icon: 'ti-shield',
    group: 'settings',
    crumbs: ['Settings', 'Two factor Auth'],
    component: TwofactorAuth,
  },
};

const GROUPS = [
  {
    id: 'workspace',
    label: 'Workspace',
  },
  {
    id: 'workspaceMetadata',
    label: 'Metadata',
  },
  {
    id: 'users',
    label: 'Users',
  },
  {
    id: 'subadmins',
    label: 'Sub Admins',
  },
  {
    id: 'governance',
    label: 'Governance',
  },
  {
    id: 'settings',
    label: 'Settings',
  },
];

function AppShell() {
  const { currentUserData } = useData();

  const [active, setActive] = useState('dashboard');
  const [topSearch, setTopSearch] = useState('');

  const ActiveComponent = MODULES[active]?.component || DashboardModule;
  const crumbs = MODULES[active]?.crumbs || ['Dashboard'];

  return (
    <div className="app">
      <Sidebar
        active={active}
        setActive={setActive}
        groups={GROUPS}
        modules={MODULES}
        counts={{}}
        currentUserData={currentUserData}
      />

      <main className="main">
        <TopBar
          crumbs={crumbs}
          topSearch={topSearch}
          setTopSearch={setTopSearch}
          currentUserData={currentUserData}
        />

        <div className="page">
          {ActiveComponent && <ActiveComponent onNavigate={setActive} />}
        </div>
      </main>
    </div>
  );
}

export default AppShell;
